const locales = [
  { code: 'tr', name: 'Türkçe' },
  { code: 'en', name: 'English' },
];

const defaultLocale = 'tr';
const fallbackLocale = 'tr';

const storageKey = 'selectedLocale';

export {
  locales,
  defaultLocale,
  fallbackLocale,
  storageKey,
};
